import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectCabinWidth from 'components/site/select_cabin_width'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectCabinWidth: state.searchFormCondition.selectCabinWidth,
})

const SelectCabinWidthContainer = connect(mapStateToProps, mapDispatchToProps)(SelectCabinWidth)

export default SelectCabinWidthContainer
